import { LocalStorageHandler } from '../utils/LocalStorageHandler';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getUser } from '../api/users';

export function useProfile() {
  const viewType = LocalStorageHandler.get('view-selected') ?? 'Standard';
  const user_role = LocalStorageHandler.get<number>('userRole') ?? 0;

  const { data, error, isLoading } = useQuery({
    queryKey: ['profile'],
    queryFn: () => getUser('profile'),
  });

  if (error) {
    LocalStorageHandler.save('userRole', 0);
  }

  if (data) {
    LocalStorageHandler.save('userRole', data.user_role);
    if (data.team_id) {
      LocalStorageHandler.save('teamId', data.team_id);
    }
  }

  const memoizedUserData = useMemo(
    () => ({
      viewType,
      user_role,
      ...data,
      show_config: !isLoading && data?.user_role >= 1000,
    }),
    [data, viewType, user_role, isLoading],
  );
  return {
    data: memoizedUserData,
    error,
    isLoading,
  };
}
